import { TOGGLE_HIDE_UNHIDE, UPDATE_FONT_SIZE } from '../actions/types';

const INIT_STATE = {
  hideColumns: true,
  fontSize: 10
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TOGGLE_HIDE_UNHIDE:
      return {
        ...state,
        hideColumns: !state.hideColumns
      };
    case UPDATE_FONT_SIZE:
      return {
        ...state,
        fontSize: action.payload
      };
    default: 
      return state;
  }
}